import { Unplug } from 'lucide-react';
import { BasePopup } from '../BasePopup';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  deviceName: string;
  isLoading: boolean;
}

export const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  deviceName,
  isLoading,
}: ConfirmDialogProps) => {
  return (
    <BasePopup
      isOpen={isOpen}
      onClose={onClose}
      title="Disconnect Device"
      icon={<Unplug className="h-6 w-6" />}
      className="max-w-md"
    >
      <div className="p-6">
        <p className="mb-6 text-gray-600">
          Are you sure you want to disconnect <strong>{deviceName}</strong>? This action cannot be
          undone.
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="rounded-md bg-gray-100 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-200"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex items-center gap-1 rounded-md bg-red-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-red-600"
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="mr-1 h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                Disconnecting...
              </>
            ) : (
              <>
                <Unplug className="h-4 w-4" />
                Disconnect
              </>
            )}
          </button>
        </div>
      </div>
    </BasePopup>
  );
};
